module.exports = __webpack_public_path__ + "img/asus.5c8da1d4.png";